import './styles/ClientRetrievalSignatureStyle.css';
import React, { useEffect, useState } from 'react';
import {
  NavigationButton,
  ToastType,
  TopNav,
  TopNavToastMessage,
} from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import SignatureCanvas from 'react-signature-canvas';
import { navigationPages } from '../../models/types';
import { useHistory } from 'react-router-dom';

const ClientRetrievalSignature: React.FC = () => {
  let sigCanvas: SignatureCanvas | null;
  let history = useHistory();
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const customerSignature = useTypedSelector(({ locker }) => {
    return locker.customerSignature;
  });
  const currentLockerPosition = useTypedSelector(({ locker }) => {
    return locker.currentLockerPosition;
  });
  const { updateCustomerSignature } = useActions();
  useEffect(() => {
    if (sigCanvas?.isEmpty() && customerSignature !== '') {
      sigCanvas.fromDataURL(customerSignature, {
        ratio: 1.5,
      });
    }
  }, [customerSignature]);
  const onStrokeEnd = () => {
    if (sigCanvas != null) {
      let stroke = sigCanvas.getTrimmedCanvas().toDataURL();
      updateCustomerSignature(stroke);
    }
  };
  const clearSignature = () => {
    if (sigCanvas != null) {
      sigCanvas.clear();
      updateCustomerSignature('');
    }
  };
  const validateSignature = () => {
    history.replace(`/${navigationPages.CLIENT_RETRIEVAL_PIECE}`);
  };
  const renderClearSignatureButton = () => {
    if (customerSignature && customerSignature !== '') {
      return (
        <button
          className="cancel-button clear-signature-button"
          onClick={() => clearSignature()}
        >
          {languageMap.client_retrieval_signature.clear_button[language]}
        </button>
      );
    }
    return null;
  };
  const renderContent = () => {
    return (
      <div className="client-signature-container">
        <div className="client-signature-tag-container">
          <p className="client-signature-tag-instructions">
            {languageMap.client_retrieval_signature.instructions[language]}
          </p>
        </div>
        <div className="client-signature-box-container">
          {renderClearSignatureButton()}
          <SignatureCanvas
            canvasProps={{
              className: 'signature-canvas',
            }}
            backgroundColor="rgba(0,0,0,0)"
            onEnd={() => {
              onStrokeEnd();
            }}
            ref={(ref) => {
              sigCanvas = ref;
            }}
          />
        </div>
      </div>
    );
  };
  return (
    <div id="clientRetrievalSignature" className="main-container">
      <TopNav dataCyPrefix="scan-awb" />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container vertical">
            <p className="header nopadding nomargin">
              {languageMap.client_retrieval_signature.title[language]}
            </p>
            <p className="subtitle nopadding">
              {languageMap.client_retrieval_name.subtitle[language]}{' '}
              {currentLockerPosition.packageCandidate?.awbNumber}
            </p>
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container">
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.client_retrieval_signature.back_button[language]
                }
                buttonClass="navigation-button cancel-button complete"
                onClickButton={() => {
                  history.replace(`/${navigationPages.CLIENT_RETRIEVAL_NAME}`);
                }}
              />
            </div>
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.client_retrieval_signature.confirm_button[
                    language
                  ]
                }
                buttonClass="navigation-button confirm-button complete"
                onClickButton={() => {
                  validateSignature();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ClientRetrievalSignature };
